/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export enum VariantType {
    Browser,
    Viewport
}

/**
 * IsMobile properties.
 */
export interface IMobileProps {
    /**
     * Contains variant i.e browser | viewport.
     */
    variant?: VariantType;
    context?: Msdyn365.IRequestContext;
}
